import { classes } from '@ardoq/common-helpers';
import { BubbleChartDataPointArgs } from './types';
import { COMPONENT_ID_ATTRIBUTE } from '@ardoq/global-consts';
import {
  CONTEXT_HIGHLIGHT_STROKE_WIDTH,
  ZERO_BUBBLE,
  ZERO_BUBBLE_SIZE,
} from './consts';

const HIGHLIGHT_GAP = 4;
const highlightRadius = (regularRadius: number) =>
  regularRadius + HIGHLIGHT_GAP + CONTEXT_HIGHLIGHT_STROKE_WIDTH / 2;

export const DataPoint = ({
  data: {
    isBlurred,
    cid,
    class: className,
    fill,
    stroke,
    x,
    y,
    radius,
    isContext,
    uniqueId,
    label,
  },
}: BubbleChartDataPointArgs) => (
  <g className="dataPoint">
    {radius ? (
      <circle
        data-global-handler-id={cid}
        data-unique-id={uniqueId}
        className={classes(
          className,
          'component-stroke',
          'dataPoint',
          isBlurred && 'blurred'
        )}
        cx={x}
        cy={y}
        r={Math.max(0, radius)}
        style={{ fill, stroke }}
        role="img"
        aria-label={label}
        {...{ [COMPONENT_ID_ATTRIBUTE]: cid }}
      />
    ) : (
      <use
        href={`#${ZERO_BUBBLE}`}
        data-unique-id={uniqueId}
        x={x}
        y={y}
        style={{ transform: `translate(${-ZERO_BUBBLE_SIZE / 2}px)` }}
      />
    )}
    {isContext && (
      <circle
        className="dataPointContextHighlight"
        r={highlightRadius(radius)}
        cx={x}
        cy={y}
      />
    )}
  </g>
);
